import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ToolPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const ToolResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.TOOL).default(ResourceType.TOOL),
    description: z.string(),
});
export const ToolMutationResourceSchema = getMutationSchema(ToolResourceSchema);

export type ToolResource = z.infer<typeof ToolResourceSchema>;

export const defaultToolResource: ToolResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.TOOL,
    description: '',
};

export function useToolActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions('project/tool', ResourceType.TOOL, ToolResourceSchema),
        ...useIndirectlyVersionedResourceAdapter('project/tool', ResourceType.TOOL, ToolResourceSchema),
    };
}
